import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/root-store/app-state';
import { getIdSelector } from 'src/app/root-store/root-store.selector';

@Component({
  selector: 'app-package-deliverable-view',
  templateUrl: './package-deliverable-view.component.html',
  styleUrls: ['./package-deliverable-view.component.scss'],
})
export class PackageDeliverableViewComponent implements OnInit {
  nodeId$: Observable<number>;
  displayedColumns: string[] = [
    'documentNumber',
    'title',
    'responsible',
    'startDate',
    'endDate',
    'hours',
    'progressWorkflowStatus',
    'percentageCompleted',
    'controlledDocument',
    'actions',
  ];
  constructor(private store$: Store<AppState>) {}

  ngOnInit(): void {
    this.nodeId$ = this.store$.select(getIdSelector);
  }
}
